import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export function AdNode(props) {
    return <NodeWithMultipleHandles {...props} nodeType="ad" />;
}
